export interface IOrderHistoryItem {
	id: number;
	action: {
		value: string;
		displayName: string;
	};
	fieldName: string;
	oldValue: string;
	newValue: string;
	description: string;
	createdAt: string;
	user: {
		id: number;
		name: string;
		/** DOVE-2388 — 'Company Portal' / 'Client Portal'; null when there is no user (HL7, jobs). */
		source: string | null;
		fullUser: {
			id: number;
			name: string | null;
			email: string;
		};
	};
	model: {
		type: string;
		id: number;
		displayName: string;
	};
	target: {
		type: string;
		id: number;
		displayName: string;
	};
}

export interface IOrderHistoryResponse {
	data: IOrderHistoryItem[];
	links: {
		first: string | null;
		last: string | null;
		prev: string | null;
		next: string | null;
	};
	meta: {
		currentPage: number;
		from: number;
		lastPage: number;
		links: Array<{
			url: string | null;
			label: string;
			active: boolean;
		}>;
		path: string;
		perPage: number;
		to: number;
		total: number;
	};
}

export class OrderHistoryItem implements IOrderHistoryItem {
	id: number;
	action: {
		value: string;
		displayName: string;
	};
	fieldName: string;
	oldValue: string;
	newValue: string;
	description: string;
	createdAt: string;
	user: {
		id: number;
		name: string;
		/** DOVE-2388 — 'Company Portal' / 'Client Portal'; null when there is no user (HL7, jobs). */
		source: string | null;
		fullUser: {
			id: number;
			name: string | null;
			email: string;
		};
	};
	model: {
		type: string;
		id: number;
		displayName: string;
	};
	target: {
		type: string;
		id: number;
		displayName: string;
	};

	constructor(data: any) {
		this.id = data.id;
		this.action = {
			value: data.action?.value || '',
			displayName: data.action?.display_name || ''
		};
		this.fieldName = data.field_name || '';
		this.oldValue = data.old_value || '';
		this.newValue = data.new_value || '';
		this.description = data.description || '';
		this.createdAt = data.created_at_iso || '';
		this.user = {
			id: data.user?.id || 0,
			name: data.user?.name || '',
			source: data.user?.source ?? null,
			fullUser: {
				id: data.user?.full_user?.id || 0,
				name: data.user?.full_user?.name || null,
				email: data.user?.full_user?.email || ''
			}
		};
		this.model = {
			type: data.model?.type || '',
			id: data.model?.id || 0,
			displayName: data.model?.display_name || ''
		};
		this.target = {
			type: data.target?.type || '',
			id: data.target?.id || 0,
			displayName: data.target?.display_name || ''
		};
	}
}
